<template>
  <div class="login">
    <v-app>
      <v-container class="fill-height" fluid>
        <v-row align="center" align-content="center" justify="center">
          <v-col cols="6">
            <v-card>
              <v-toolbar dark flat>
                <v-toolbar-title>SIENG MANAGEMENT</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form ref="loginForm"
                        :lazy-validation=true
                        @keyup.native.enter="login"
                >
                  <v-text-field
                    v-model="loginId"
                    :rules="notEmptyValidation"
                    label="ID"
                    name="loginId"
                    prepend-icon="person"
                    type="text"
                    required
                  />

                  <v-text-field
                    v-model="password"
                    :rules="notEmptyValidation"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    required
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn text @click="login">로그인</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-app>
  </div>
</template>

<script>
  export default {
    name: 'login',
    data() {
      return {
        loginId: '',
        password: '',
        notEmptyValidation: [
          value => !!value || '필수 값입니다'
        ],
      }
    },
    methods: {
      login() {
        this.$refs.loginForm.validate();
        this.$bus.$emit('login', this.loginId, this.password);
      }
    }
  }
</script>